import { BLACK } from '../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../theme/fontConstants';

export const getColors = ({ theme }) => ({
  selectedBackgroundColor: theme?.jobOrders?.createPage?.cadence?.selectedBackgroundColor,
  unSelectedBackgroundColor: theme?.jobOrders?.createPage?.cadence?.unSelectedBackgroundColor,
  wrapperBackgroundColor: theme?.jobOrders?.createPage?.cadence?.wrapperBackgroundColor,
  errorColor: theme?.jobOrders?.createPage?.cadence?.errorColor,
});

export const getStyles = ({ theme, error }) => {
  const { selectedBackgroundColor, unSelectedBackgroundColor, wrapperBackgroundColor, errorColor } =
    getColors({ theme });

  const wrapperSx = {
    backgroundColor: wrapperBackgroundColor,
    border: error && '1px solid red',
    justifyContent: 'space-around',
    borderRadius: theme.spacing(1),
    width: '100%',
  };

  const boxSx = {
    margin: theme.spacing(1.5, 0),
    borderRadius: theme.spacing(0.5),
    cursor: 'pointer',
  };

  const selectedBoxSx = {
    ...boxSx,
    backgroundColor: selectedBackgroundColor,
  };

  const unSelectedBoxSx = {
    ...boxSx,
    backgroundColor: unSelectedBackgroundColor,
  };

  const labelSx = {
    color: BLACK[60],
    fontFamily: PRIMARY_FONT[400],
    fontSize: '14px',
  };

  const labelSelectedSx = {
    color: BLACK[100],
    fontFamily: PRIMARY_FONT[500],
    fontSize: '14px',
  };

  const helperTextSx = {
    color: errorColor,
    fontFamily: PRIMARY_FONT[500],
    fontSize: '14px',
  };
  const textWrapper = {
    justifyContent: 'center',
    alignItems: 'center',
    height: '35px',
  };

  return {
    wrapperSx,
    selectedBoxSx,
    unSelectedBoxSx,
    labelSx,
    labelSelectedSx,
    helperTextSx,
    textWrapper,
  };
};
